var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { ApolloClient, HttpLink, InMemoryCache, } from '@apollo/client';
export default (function (options) {
    if (!options) {
        return new ApolloClient({
            cache: new InMemoryCache().restore({}),
        });
    }
    var _a = options.cache, cache = _a === void 0 ? new InMemoryCache().restore({}) : _a, uri = options.uri, credentials = options.credentials, headers = options.headers, _b = options.link, link = _b === void 0 ? !!uri ? new HttpLink({ uri: uri, credentials: credentials, headers: headers }) : undefined : _b, otherOptions = __rest(options, ["cache", "uri", "credentials", "headers", "link"]);
    return new ApolloClient(__assign({ link: link, cache: cache }, otherOptions));
});
//# sourceMappingURL=buildApolloClient.js.map